import Template from "./Builder";
import Config from "./Config";

export default function TemplateBuilderTab({ data, onChange, disabled }) {
  return <>
    <Config data={data} onChange={onChange} disabled={disabled} />
    <Template data={data} onChange={onChange} disabled={disabled} />
  </>
}
